<template>
  <window-portal
    :open="dataRegular.show"
    @close="
      () => {
        dataRegular.show = false;
        if (dataRegular?.closeCallback) {
          dataRegular?.closeCallback();
        }
        dataTicket.show = false;
        if (dataTicket?.closeCallback) {
          dataTicket?.closeCallback();
        }
      }
    "
  >
    <print-pos-factura-regular
      v-if="type === 'regular'"
      v-model="type"
      :dataProps="dataRegular"
      :hideQr="hideQr"
    ></print-pos-factura-regular>
    <print-pos-factura-ticket
      v-else-if="type === 'ticket' && !isNormalTicketV2Enabled()"
      v-model="type"
      :dataProps="dataTicket"
      :hideQr="hideQr"
    ></print-pos-factura-ticket>
    <print-pos-factura-ticket-v2
      v-else-if="type === 'ticket' && isNormalTicketV2Enabled()"
      v-model="type"
      :dataProps="dataTicket"
      :hideQr="hideQr"
    ></print-pos-factura-ticket-v2>
  </window-portal>
</template>

<script>
// import PrintPosFacturaRegular from "./PrintPosFacturaRegular.vue";
import PrintPosFacturaTicket from "./PrintPosFacturaTicket.vue";
import PrintPosFacturaTicketV2 from "./PrintPosFacturaTicketV2.vue";
import PrintPosFacturaRegular from "./PrintPosFacturaRegular.vue"
import WindowPortal from "./WindowPortal.vue";

export default {
  name: "PrintPosFactura",
  props: {
    dataTicket: {
      type: Object,
      default: () => ({}),
    },
    dataRegular: {
      type: Object,
      default: () => ({}),
    },
    hideQr: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    WindowPortal,
    PrintPosFacturaRegular,
    PrintPosFacturaTicket,
    PrintPosFacturaTicketV2,
  },
  data: () => ({
    type: "regular", // regular, ticket
  }),
  methods: {
    isNormalTicketV2Enabled() {
      const user = JSON.parse(localStorage.getItem("user")) || {};
      return user.usenormalticketv2 === 1 || user.usenormalticketv2 === "1" || user.usenormalticketv2 === true;
    },
  },
  watch: {
    "dataRegular.show"(value) {
      if (!value) {
        this.type = "regular";
      }
    },
  },
};
</script>
